<script>
import { mapState } from "vuex";

import Header from "./CycleComponents/Header";
import CycleDetails from "./CycleComponents/CycleDetails";
import CycleOrders from "./CycleComponents/CycleOrders";
import Total from "./CycleComponents/Total";

export default {
  components: {
    Header,
    CycleDetails,
    CycleOrders,
    Total
  }
};
</script>

<template>
  <div>
    <Header />
    <CycleDetails />
    <CycleOrders />
    <Total />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payable/Cycle.vue